import { render } from "./LbrxKioskSixthTheme.vue?vue&type=template&id=0c67b2c6&scoped=true"
import script from "./LbrxKioskSixthTheme.vue?vue&type=script&lang=js"
export * from "./LbrxKioskSixthTheme.vue?vue&type=script&lang=js"

import "./LbrxKioskSixthTheme.vue?vue&type=style&index=0&id=0c67b2c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c67b2c6"]])

export default __exports__